export default "__VITE_ASSET__904cb15c__$_?nuxt_component=async__"